export default ({
    date,
    links = {},
    dateFormat = 'DD-MM-YY',
    availability = 0
}) => {
    if (typeof date !== 'string') {
        throw new TypeError('date must be of type `string`');
    }

    return {
        date,
        links,
        dateFormat,
        availability
    }
};